import { render, staticRenderFns } from "./BrickDedupTargetSettings.vue?vue&type=template&id=45a10534&scoped=true&"
import script from "./BrickDedupTargetSettings.vue?vue&type=script&lang=js&"
export * from "./BrickDedupTargetSettings.vue?vue&type=script&lang=js&"
import style0 from "./BrickDedupTargetSettings.vue?vue&type=style&index=0&id=45a10534&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45a10534",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("Q:\\Projects\\marketingdatabase-git\\MarketingDb.Web.Zeiss\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('45a10534')) {
      api.createRecord('45a10534', component.options)
    } else {
      api.reload('45a10534', component.options)
    }
    module.hot.accept("./BrickDedupTargetSettings.vue?vue&type=template&id=45a10534&scoped=true&", function () {
      api.rerender('45a10534', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Modules/JourneyBuilder/Components/Composer/CanvasArea/Bricks/Settings/Connection/BrickDedupTargetSettings.vue"
export default component.exports